import { render, staticRenderFns } from "./CalendarioDoctores.vue?vue&type=template&id=1a5bf80e&scoped=true"
import script from "./CalendarioDoctores.vue?vue&type=script&lang=js"
export * from "./CalendarioDoctores.vue?vue&type=script&lang=js"
import style0 from "./CalendarioDoctores.vue?vue&type=style&index=0&id=1a5bf80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bf80e",
  null
  
)

export default component.exports